import React, { FC, useState } from "react";
import useAppStore from "../Store/AppStore";
import "./YearFilter.scss";
import { useTranslation } from "react-i18next";

import ArrowUp from "../../assets/Arrow.svg";
import Calendar from "../../assets/Calendar.svg";

const YearFilter: FC = () => {
  const { t } = useTranslation();

  // YearFilter is maybe not the right word, use YearChooser or better Campaign- throughout the code

  // Use the scss files for component-specific styling
  // Scope styling using nested classes (e. g. per component)

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const yearFilterValues = useAppStore((state) => state.yearFilterValues);
  const select = useAppStore((state) => state.setYearFilter);

  return (
    <>
      <label
        className="year-label mb-1 pt-2 uppercase text-xs text-grayLabel font-black"
        htmlFor="mess"
      >
        {t("Messkampagne")}
      </label>

      <div className="year-input-wrapper relative xl:w-[175px]">
        <button
          className="flex justify-between items-center xl:w-full p-1 bg-white border border-gray550 "
          onClick={() => setDropdownOpen(!isDropdownOpen)}
        >
          <div className="flex items-center">
            <img src={Calendar} className="w-[18px] h-[18px]" />
            <p className="year-text-input h-[20px] w-[120px] pt-[2px] pl-[10px] text-xs text-start text-ellipsis overflow-hidden whitespace-nowrap">
              {yearFilterValues.find((lf) => lf.selected === true).label}
            </p>
          </div>
          <img
            className="year-arrow-icon"
            src={ArrowUp}
            style={{
              transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            alt="Arrow Icon"
          />
        </button>
          {isDropdownOpen && (
              <ul className="year-dropdown absolute top-10 z-10 xl:w-full bg-white rounded-md p-2">
                  {yearFilterValues.map((option) => (
                      <li key={option.id} className="my-2">
                          <label className="flex items-start cursor-pointer">
                              <input
                                  type="checkbox"
                                  className="form-checkbox mr-2"
                                  checked={option.selected}
                                  onChange={() => select(option.id)}
                              />
                              <span className="text-xs">{option.label}</span>
                          </label>
                      </li>
                  ))}
              </ul>
          )}
      </div>
    </>
  );
};

export default YearFilter;
